module.exports = __webpack_public_path__ + "files/0fbf3e42c6faa5a38aca658c41cc3acb.png";